import React, { useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Input } from "../../Form";
import RadioGroup from "../../Form/RadioGroup";
import Modal from "../Modal";
import useStyles from "./styles";

interface Props {
  open: boolean;
  closeModal: () => void;
  handleChange: (type: string, value: string) => void;
}

const AddSpecialInstructionModal = ({ open, closeModal, handleChange }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [instruction, setInstruction] = useState<string>("");
  const [type, setType] = useState<string>("");
  const submit = () => {
    handleChange(type, instruction);
    handleCloseModal();
  };

  const clearFields = () => {
    setType("");
    setInstruction("");
  };

  const handleCloseModal = () => {
    closeModal();
    clearFields();
  };

  return (
    <Modal
      open={open}
      handleClose={handleCloseModal}
      className={classes.modal}
      title={translate("addInstruction")}
      showActionButtons
      actionButtonProps={{
        onSave: submit,
        onCancel: () => {
          handleCloseModal();
        },
        dataCySave: "buttonSaveInstruction",
        textSave: translate("add"),
        saveDisabled: type === "" || instruction.trim() === "",
      }}
    >
      <Grid container direction="column" data-cy="modalAddInstruction">
        <span className={classes.typeOfInstructionLabel}>
          {translate("typeOfInstruction")}
        </span>

        <RadioGroup
          aria-label="type"
          name="radio-type-instruction"
          value={type}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setType(event.target.value)}
          options={[
            {
              label: translate("pickUp"),
              value: "pickup",
              "data-cy": "radioTypeInstructionPickup",
            },
            {
              label: translate("delivery"),
              value: "delivery",
              "data-cy": "radioTypeInstructionDelivery",
            },
          ]}
        />

        <Input
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter" && type !== "" && instruction.trim() !== "") {
              submit();
              handleCloseModal();
            }
          }}
          value={instruction}
          placeholder={translate("inputYourInstruction")}
          data-cy="textareaInstruction"
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
            setInstruction(event.target.value)
          }
        />
      </Grid>
    </Modal>
  );
};

export default AddSpecialInstructionModal;
